import {spawnErrorToast} from '@hm/fundamental'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {useRefraQuery} from '@refra/modules/common/hooks'
import {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

interface useBrickCalculationQueryParams {
  plantUpmId: string
  kilnUpmId: string
  shutdownId: number
  installationId: number
  brickShape1: string
  brickShape2: string
  keyBricksCount: number
  useRefratechnikKeyBricks: boolean
  enabled?: boolean
}

export const useBrickCalculationQuery = ({
  plantUpmId,
  kilnUpmId,
  shutdownId,
  installationId,
  brickShape1,
  brickShape2,
  keyBricksCount,
  useRefratechnikKeyBricks,
  enabled = true
}: useBrickCalculationQueryParams) => {
  const {t} = useTranslation()

  return useRefraQuery({
    queryKey: 'brickCalculation',
    params: [
      {
        plantUpmId,
        kilnUpmId,
        shutdownId,
        installationId,
        brickShape1,
        brickShape2,
        keyBricksCount,
        useRefratechnikKeyBricks
      }
    ],
    retry: 0,
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useBrickCalculationQuery')
        .extras({errorDetails, plantUpmId, kilnUpmId})
        .error('Error occurred while fetching brick calculation')

      spawnErrorToast(axiosError?.response?.data?.message ?? t('error.brickCalculationQuery'))

      return false
    },
    enabled
  })
}
